import { useEffect, useRef, useState } from "react";
import Fileupload from "../../components/Fileupload";
import LoadingScreen from "react-loading-screen";
import { get_page_creation, page_creation } from "../../api/api";
import { toast } from "react-toastify";

const fullConfig = {
  creation: [
    { name: "E-ISBN", type: "number" },
    { name: "P-ISBN", type: "number" },
    { name: "Title Name", type: "text" },
    { name: "Author Name", type: "text" },
    {
      name: "Language",
      type: "select",
      list: [{ id: 1, value: "en" }],
    },
    { name: "Publisher", type: "text" },
    { name: "Page Count", type: "number" },
  ],
  summary: [
    { id: 1, name: "Simple" },
    { id: 2, name: "Medium" },
    { id: 3, name: "Complex" },
  ],
  certified: [
    { id: 1, name: "Transforma" },
    { id: 2, name: "Benetech" },
  ],
  pageList: [
    { id: 1, name: "Nav Page List" },
    { id: 2, name: "Ncx Page List" },
  ],
  schema: [
    {
      id: 1,
      name: "Access Mode",
      schema_drop: [
        { id: 1, name: "auditory" },
        { id: 2, name: "tactile" },
        { id: 3, name: "visual" },
        { id: 4, name: "textual" },
      ],
    },
    {
      id: 2,
      name: "Sufficient Access Modes",
      schema_drop: [
        { id: 5, name: "auditory" },
        { id: 6, name: "textual" },
        { id: 7, name: "visual" },
        { id: 8, name: "textual visual" },
      ],
    },
    {
      id: 3,
      name: "Accessibility Features",
      schema_drop: [
        { id: 9, name: "alternativeText" },
        { id: 10, name: "annotations" },
        { id: 11, name: "ARIA" },
        { id: 12, name: "index" },
        { id: 13, name: "longDescription" },
        { id: 14, name: "MathML" },
        { id: 15, name: "pageBreakMarkers" },
        { id: 16, name: "pageNavigation" },
        { id: 17, name: "readingOrder" },
        { id: 18, name: "structuralNavigation" },
        { id: 19, name: "tableOfContents" },
        { id: 20, name: "audioDescription" },
        { id: 21, name: "bookmarks (deprecated)" },
        { id: 22, name: "braille" },
        { id: 23, name: "captions (deprecated)" },
        { id: 24, name: "ChemML" },
        { id: 25, name: "closedCaptions" },
        { id: 26, name: "describedMath" },
        { id: 27, name: "displayTransformability" },
        { id: 28, name: "fullRubyAnnotations" },
        { id: 29, name: "highContrastAudio" },
        { id: 30, name: "highContrastDisplay" },
        { id: 31, name: "horizontalWriting" },
        { id: 32, name: "largePrint" },
        { id: 33, name: "latex" },
        { id: 34, name: "openCaptions" },
        { id: 35, name: "rubyAnnotations" },
        { id: 36, name: "signLanguage" },
        { id: 37, name: "synchronizedAudioText" },
        { id: 38, name: "tactileGraphic" },
        { id: 39, name: "tactileObject" },
        { id: 40, name: "taggedPDF" },
        { id: 41, name: "timingControl" },
        { id: 42, name: "transcript" },
        { id: 43, name: "ttsMarkup" },
        { id: 44, name: "unknown" },
        { id: 45, name: "unlocked" },
        { id: 46, name: "verticalWriting" },
        { id: 47, name: "withAdditionalWordSegmentation" },
        { id: 48, name: "withoutAdditionalWordSegmentation" },
      ],
    },
    {
      id: 4,
      name: "Accessibility Hazards",
      schema_drop: [{ id: 49, name: "none" }],
    },
  ],
};

export const PackageCreation = ({ renderPage }) => {
  const [creationData, setCreationData] = useState({
    ePup: {},
    schema: {},
    summary: "",
    pageList: {},
    frontCover: "",
    backCover: "",
    file: null,
    certifiedBy: "",
    RomanPageCount: "",
  });
  const [apiData, setApiData] = useState(null);
  const [dropdownOpen, setDropdownOpen] = useState({});
  const [dropOpen, setDropOpen] = useState({});
  const [file, setFile] = useState(null);
  const [validate, setValiDate] = useState({});
  const [schemaData, setSchemaData] = useState({});
  const [loading, setLoading] = useState(false);
  const [emptyFiles, setEmptyFiles] = useState(0);
  const [schemaChecked, setSchemaChecked] = useState({});
  const [loader, setLoader] = useState(false);
  let category = "7";

  const handleCreateData = (e, dataset, type) => {
    const { name, value } = e.target; // fix destructuring
    if (dataset === "ePup") {
      if (type === "number") {
        const isValid = /^\d+(\.\d+)?$/.test(value);

        if (isValid) {
          setCreationData((prev) => ({
            ...prev,
            ePup: {
              ...prev.ePup,
              [name]: value,
            },
          }));
        } else {
          setCreationData((prev) => ({
            ...prev,
            ePup: {
              ...prev.ePup,
              [name]: "",
            },
          }));
        }
      } else {
        setCreationData((prev) => ({
          ...prev,
          ePup: {
            ...prev.ePup,
            [name]: value,
          },
        }));
      }

      setDropdownOpen({});
      setDropOpen({});
    }

    // else if (dataset === "pageList") {
    //     const Sname = e.target.dataset.name; // Get the name from data attribute
    //     const Svalue = e.target.textContent;
    //     setCreationData((prev) => ({
    //         ...prev,
    //         pageList: {
    //             ...prev.pageList,
    //             [Sname]: Sname // dynamically add key-value pair
    //         }
    //     }));
    //     // setDropOpen({})
    // }
    else if (dataset === "summary") {
      const Sname = e.target.dataset.name; // Get the name from data attribute
      const Svalue = e.target.textContent;
      setCreationData((prev) => ({
        ...prev,
        [Sname]: Svalue,
      }));
      setDropOpen({});
    } else if (dataset == "RomanPageCount") {
      if (/^\d*\.?\d*$/.test(value)) {
        setCreationData((prev) => ({
          ...prev,
          [name]: value,
        }));
      }
      setDropOpen({});
    } else {
      setCreationData((prev) => ({
        ...prev,
        [name]: value,
      }));
      setDropOpen({});
    }
  };
  const handleEpopSelect = (e, dataset) => {
    const name = e.target.dataset.name; // Get the name from data attribute
    const value = e.target.textContent; // fix destructuring
    if (dataset == "ePup") {
      setCreationData((prev) => ({
        ...prev,
        ePup: {
          ...prev.ePup,
          [name]: value, // dynamically add key-value pair
        },
      }));
      setDropdownOpen({});
    }
  };
  const handleSchemaSelect = (name, value) => {
    setCreationData((prev) => ({
      ...prev,
      schema: {
        ...prev.schema,
        [name]: Array.isArray(prev.schema[name])
          ? prev.schema[name].includes(value) // Check if the value already exists
            ? prev.schema[name].filter((item) => item !== value) // Remove the value if it's already there
            : [...prev.schema[name], value] // Add the value if it's not present
          : [value], // If it's not an array, make it one with the value
      },
    }));
  };
  const handlePageSelect = (name) => {
    setCreationData((prev) => ({
      ...prev,
      pageList: {
        ...prev.pageList,
        [name]: prev.pageList[name] == name ? "" : name, // If it's not an array, make it one with the value
      },
    }));
  };
  const handleCancel = () => {
    setEmptyFiles((prev) => prev + 1);
    setValiDate({});
    setCreationData({
      ePup: apiData?.creation.reduce((acc, { name }, i) => {
        if (name) acc[name] = "";
        return acc;
      }, {}),
      schema: apiData?.schema.reduce((acc, { name }, i) => {
        if (name) {
          acc[name] = [];
        }
        return acc;
      }, {}),
      summary: "",
      pageList: {},
      frontCover: "",
      backCover: "",
      file: null,
      certifiedBy: "",
      RomanPageCount: "",
    });
    setSchemaChecked({});
    setDropOpen({});
    setDropdownOpen({});
  };

  useEffect(() => {
    setCreationData((prev) => ({
      ...prev,
      file: file,
    }));
  }, [file]);

  useEffect(() => {
    if (Object.keys(creationData?.schema).length) {
      Object.keys(creationData?.schema).forEach((name) => {
        if (schemaData[name] == creationData?.schema[name]?.length) {
          setSchemaChecked((prev) => ({
            ...prev,
            [name]: true, // Toggle or add with true if not present
          }));
        } else {
          setSchemaChecked((prev) => ({
            ...prev,
            [name]: false, // Toggle or add with true if not present
          }));
        }
      });
    }
  }, [creationData?.schema]);

  useEffect(() => {
    if (apiData) {
      const newSchemaData = {};
      apiData?.schema.forEach((schema) => {
        newSchemaData[schema.name] = schema.schema_drop.length;
      });
      setSchemaData(newSchemaData);
    }
  }, [apiData]);

  const fetchdata = async () => {
    try {
      let data = await get_page_creation();
      if (data) {
        setApiData(data.data);
      } else {
        toast.error(data.error);
      }
    } catch (e) {
      toast.error(e);
    }
  };

  useEffect(() => {
    fetchdata();
  }, []);

  const toggleDropdown = (index) => {
    setDropdownOpen((prev) => ({
      [index]: !prev[index],
    }));
    setDropOpen({});
  };
  const schemaDropdown = (index) => {
    setDropOpen((prev) => ({
      [index]: !prev[index],
    }));
    setDropdownOpen({});
  };

  const validateCreationData = (data) => {
    let errors = {};

    if (!Object.values(creationData?.schema).flat().length)
      errors.schema = "Schema is required.";
    if (!data.summary.trim()) errors.summary = "Summary is required.";

    if (!Object.keys(data.pageList).length)
      errors.pageList = "Page list is required.";
    if (!data.frontCover.trim()) errors.frontCover = "Front cover is required.";
    if (!data.backCover.trim()) errors.backCover = "Back cover is required.";
    if (!data?.file || !Object.values(data.file).flat().filter(Boolean).length)
      errors.file = "File is required.";
    if (!data.certifiedBy.trim())
      errors.certifiedBy = "Certified by is required.";
    if (!data.RomanPageCount || !data.RomanPageCount?.trim())
      errors.RomanPageCount = "Page count  is required.";
    const ePupErrors = {};
    for (const key in data.ePup) {
      if (!data.ePup[key].trim()) {
        ePupErrors[key] = `${key} is required.`;
      }
    }
    if (Object.keys(ePupErrors).length > 0) {
      errors.ePup = ePupErrors;
    }
    setValiDate(errors);
    return errors;
  };

  const downloadfile = (url, filename) => {
    if (url) {
      const link = document.createElement("a");
      link.href = url;
      link.download = `${filename}`; // You can specify the name of the file here
      link.click();
      // Clean up the URL object
      window.URL.revokeObjectURL(url);
    } else {
      // alert("No File to Download");
      toast.info("No Files to Download");
    }
  };

  const downloadreport = (data, filename) => {
    try {
      const file = data;
      const byteCharacters = atob(file);
      const byteArrays = [];

      for (let offset = 0; offset < byteCharacters.length; offset += 1024) {
        const slice = byteCharacters.slice(offset, offset + 1024);
        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }
        byteArrays.push(new Uint8Array(byteNumbers));
      }
      // console.log(byteArrays);
      const blob = new Blob(byteArrays, { type: "application/zip" });
      const url = window.URL.createObjectURL(blob);
      downloadfile(url, filename);
    } catch (e) {
      console.log(e);
    }
  };

  const handleAllSelect = (name) => {
    if (!schemaChecked[name]) {
      setCreationData((prev) => ({
        ...prev,
        schema: {
          ...prev.schema,
          [name]: apiData?.schema.reduce((acc, item) => {
            if (item.name === name) {
              // Map the schema_drop array to get the names
              acc = item.schema_drop.map((drop) => drop.name);
            }
            return acc;
          }, []), // If it's not an array, make it one with the value
        },
      }));
      setSchemaChecked((prev) => ({
        ...prev,
        [name]: true, // Toggle or add with true if not present
      }));
    } else {
      setCreationData((prev) => ({
        ...prev,
        schema: {
          ...prev.schema,
          [name]: [], // If it's not an array, make it one with the value
        },
      }));
      setSchemaChecked((prev) => ({
        ...prev,
        [name]: false,
      }));
    }
  };
  const handleSubmit = async (event) => {
    const button = event.currentTarget;
    button.disabled = true; // Disable the button
    document.body.style.cursor = "wait";
    setLoader(true);

    const validation = validateCreationData(creationData);
    if (Object.keys(validation).length > 0) {
      toast.warn("Please fill All fields");
      document.body.style.cursor = "default";
      button.disabled = false;
      setLoader(false);
    } else {
      try {
        const data = await page_creation(creationData);

        if (data.data) {
          downloadreport(data.data?.content, data.data?.file_name);
          toast.success("Package Creation Successful");
          setEmptyFiles((prev) => prev + 1);
          setCreationData({
            ePup: apiData?.creation.reduce((acc, { name }, i) => {
              if (name) acc[name] = "";
              return acc;
            }, {}),
            schema: apiData?.schema.reduce((acc, { name }, i) => {
              if (name) {
                acc[name] = [];
              }
              return acc;
            }, {}),
            summary: "",
            pageList: {},
            frontCover: "",
            backCover: "",
            file: null,
            certifiedBy: "",
            RomanPageCount: "",
          });
          document.body.style.cursor = "default";
          button.disabled = false;
          setLoader(false);
        } else if (data.error) {
          toast.error(data.error.message);
        }
      } catch (error) {
        if (error.code === "ECONNABORTED") {
          toast.error("Request timed out");
        } else if (error.response) {
          // Server responded with a status (e.g., 500, 400)
          const status = error.response.status;
          const msg =
            error.response.data?.message || `Server error (${status})`;
          toast.error(msg);
        } else if (error.request) {
          // Request was made but no response received
          toast.error("No response from server. Connection may have closed.");
        } else {
          // Something else happened in setting up the request
          toast.error(`Unexpected error: ${error.message}`);
        }
        document.body.style.cursor = "default";
        button.disabled = false;
        setLoader(false);
      }
    }
  };

  useEffect(() => {
    if (apiData) {
      setCreationData((prev) => ({
        ...prev,
        ePup: apiData?.creation.reduce(
          (acc, { name }) => {
            if (name) {
              acc[name] = "";
            }
            return acc;
          },
          { ...prev.ePup }
        ),
        schema: apiData?.schema.reduce(
          (acc, { name }) => {
            if (name) {
              acc[name] = [];
            }
            return acc;
          },
          { ...prev.schema }
        ),
      }));
    }
  }, [apiData]);
  useEffect(() => {
    // Stop scrolling when the loader is active
    if (loader) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    // Cleanup to reset scroll behavior when the component unmounts
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [loader]);

  return (
    <LoadingScreen
      loading={loading}
      bgColor="#f1f1f1"
      spinnerColor="#1A53A9"
      textColor="#1A53A9"
      text="Processing file please wait ...."
    >
      {loader && (
        <div className="relative">
          <div className="absolute inset-0 z-10 top-[60vw] flex items-center justify-center bg-white/50 backdrop-blur-sm">
            <div className="flex items-center gap-3">
              <span className="text-xl font-semibold text-dimtext">
                processing...
              </span>
            </div>
          </div>
        </div>
      )}
      {apiData ? (
        <div
          className={`flex flex-col w-full bg-commonfill p-8 ${
            loader ? "blur-sm pointer-events-none" : ""
          }`}
        >
          <form
            onSubmit={(e) => e.preventDefault()}
            className="flex flex-col gap-8"
          >
            <div className="w-full flex flex-col gap-6 p-6 bg-white rounded-[16px] shadow-commonshadow">
              <div className="w-full flex flex-col text-left gap-5 mb-5">
                <p className="text-black font-semibold text-20">
                  ePub creation V1.0<span className="text-red">*</span>
                </p>
                <div className="w-full grid grid-cols-3 gap-5">
                  {apiData?.creation.map((item, i) => (
                    <>
                      {item?.type == "text" || item?.type == "number" ? (
                        <div className="flex flex-col">
                          <div
                            key={i}
                            className="border-[1px] border-commonborder rounded-[12px] px-3 py-3"
                          >
                            <input
                              onKeyDown={(e) => {
                                if (e.key === "Enter") e.preventDefault();
                              }}
                              className="w-full outline-none"
                              type="text"
                              placeholder={item?.name}
                              name={item?.name}
                              value={creationData?.ePup?.[item?.name]}
                              onChange={(e) =>
                                handleCreateData(e, "ePup", item?.type)
                              }
                            />
                          </div>
                          {validate && validate?.ePup?.[item?.name] ? (
                            <p className="text-red">
                              {" "}
                              {"*"}
                              {validate.ePup[item?.name]}
                            </p>
                          ) : (
                            <></>
                          )}
                        </div>
                      ) : (
                        <>
                          <div
                            key={i}
                            // className="border-[1px] border-commonborder rounded-[12px] px-3 py-3"
                          >
                            <div className="relative">
                              {/* Dropdown Button */}
                              <div
                                className="schemadropdown bg-white border-[1px] border-commonborder rounded-[12px] px-3 py-3 w-full text-left flex justify-between items-center text-dimtext"
                                onClick={() => toggleDropdown(i)} // Toggle dropdown for the specific index
                              >
                                <p
                                  className={`w-full overflow-hidden  ${
                                    creationData?.ePup[item?.name]
                                      ? "text-black"
                                      : "text-dimtext"
                                  }`}
                                >
                                  {creationData?.ePup[item?.name]
                                    ? creationData?.ePup[item?.name]
                                    : item?.name}
                                </p>
                                <span className="ml-2">
                                  {!dropdownOpen[i] ? (
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      className="h-4 w-4"
                                      viewBox="0 0 20 20"
                                      fill="currentColor"
                                    >
                                      <path
                                        fillRule="evenodd"
                                        d="M5.293 9.293a1 1 0 011.414 0L10 12.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                                        clipRule="evenodd"
                                      />
                                    </svg>
                                  ) : (
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      className="h-4 w-4"
                                      viewBox="0 0 20 20"
                                      fill="currentColor"
                                    >
                                      <path
                                        fillRule="evenodd"
                                        d="M14.707 10.707a1 1 0 01-1.414 0L10 7.414l-3.293 3.293a1 1 0 11-1.414-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 010 1.414z"
                                        clipRule="evenodd"
                                      />
                                    </svg>
                                  )}
                                </span>
                              </div>

                              {/* Dropdown Menu */}
                              {dropdownOpen[i] && (
                                <ul
                                  // ref={schemaref}
                                  className="absolute z-10 bg-white border border-gray-300 rounded-lg w-full mt-2 shadow-lg max-h-[300px] overflow-auto"
                                >
                                  {item.list.map((option, index) => (
                                    <li
                                      data-name={item?.name}
                                      key={index}
                                      className={`px-4 py-2 hover:bg-gray-100 cursor-pointer `}
                                      // ${creationData?.ePup?.[item?.name]==option?.value?"bg-gray-100":""}
                                      onClick={(e) =>
                                        handleEpopSelect(e, "ePup")
                                      }
                                    >
                                      {option.name}
                                    </li>
                                  ))}
                                </ul>
                              )}
                            </div>
                            {validate && validate?.ePup?.[item?.name] ? (
                              <p className="text-red">
                                {" "}
                                {"*"}
                                {validate.ePup[item?.name]}
                              </p>
                            ) : (
                              <></>
                            )}
                          </div>
                        </>
                      )}
                    </>
                  ))}
                </div>
              </div>
              <div className="w-full flex  text-left gap-5 mb-5">
                <div className="flex flex-col w-1/3 min-w-[150px] gap-5">
                  <p className="text-black font-semibold text-20">
                    Schema Access Mode<span className="text-red">*</span>
                  </p>

                  <div className="relative">
                    {/* Dropdown Button */}
                    <div
                      className="schemadropdown bg-white border-[1px] border-commonborder rounded-[12px] px-3 py-3 w-full text-left flex justify-between items-center text-dimtext"
                      onClick={() => schemaDropdown(0)} // Toggle dropdown for the specific index
                    >
                      <p
                        className={`w-full overflow-auto max-h-[70px] ${
                          Object.values(creationData?.schema).flat().length
                            ? "text-black"
                            : "text-dimtext"
                        }`}
                      >
                        {Object.values(creationData?.schema).flat().length
                          ? Object.values(creationData?.schema)
                              .flat()
                              .join(", ")
                          : "Select mode and features"}
                      </p>
                      <span className="ml-2">
                        {!dropOpen[0] ? (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-4 w-4"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                          >
                            <path
                              fillRule="evenodd"
                              d="M5.293 9.293a1 1 0 011.414 0L10 12.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                              clipRule="evenodd"
                            />
                          </svg>
                        ) : (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-4 w-4"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                          >
                            <path
                              fillRule="evenodd"
                              d="M14.707 10.707a1 1 0 01-1.414 0L10 7.414l-3.293 3.293a1 1 0 11-1.414-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 010 1.414z"
                              clipRule="evenodd"
                            />
                          </svg>
                        )}
                      </span>
                    </div>

                    {/* Dropdown Menu */}
                    {dropOpen[0] && (
                      <div className="bg-white border absolute z-10 border-gray-300 rounded-lg w-full mt-2 shadow-lg max-h-[300px] overflow-auto">
                        {apiData?.schema.map((item, i) => (
                          <div className="flex flex-col ">
                            <div className="px-4 py-2 bg-gray-100 text-18 justify-between font-semibold flex ">
                              <span>{item?.name}</span>
                              <input
                                type="checkbox"
                                className="w-[20px] h-[20px]"
                                checked={schemaChecked[item?.name]}
                                onChange={() => handleAllSelect(item?.name)}
                                name={item?.name}
                              />
                            </div>

                            <ul
                              // ref={schemaref}
                              className=""
                            >
                              {item.schema_drop.map((option, index) => (
                                <li
                                  key={index}
                                  className={`px-4 py-2 hover:bg-gray-100 cursor-pointer break-all flex gap-4 items-center justify-between`}
                                  onClick={(e) =>
                                    handleSchemaSelect(item.name, option.name)
                                  }
                                >
                                  <span>{option?.name}</span>
                                  <input
                                    type="checkbox"
                                    className="w-[20px] h-[20px]"
                                    checked={creationData?.schema?.[
                                      item?.name
                                    ]?.includes(option?.name)}
                                  />
                                </li>
                              ))}
                            </ul>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                  {validate && validate?.schema ? (
                    <p className="text-red">
                      {" "}
                      {"*"}
                      {validate.schema}
                    </p>
                  ) : (
                    <></>
                  )}
                </div>
                <div className="flex flex-col w-1/3 min-w-[150px] gap-5">
                  <p className="text-black font-semibold text-20">
                    Summary<span className="text-red">*</span>
                  </p>

                  <div className="w-full flex flex-col gap-5">
                    <div className="relative">
                      {/* Dropdown Button */}
                      <div
                        className="schemadropdown bg-white border-[1px] border-commonborder rounded-[12px] px-3 py-3 w-full text-left flex justify-between items-center text-dimtext"
                        onClick={() => schemaDropdown(1)} // Toggle dropdown for the specific index
                      >
                        <p
                          className={`w-full overflow-hidden  ${
                            creationData?.summary
                              ? "text-black"
                              : "text-dimtext"
                          }`}
                        >
                          {creationData?.summary
                            ? creationData?.summary
                            : "Select Complexity Level"}
                        </p>
                        <span className="ml-2">
                          {!dropOpen[1] ? (
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              className="h-4 w-4"
                              viewBox="0 0 20 20"
                              fill="currentColor"
                            >
                              <path
                                fillRule="evenodd"
                                d="M5.293 9.293a1 1 0 011.414 0L10 12.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                                clipRule="evenodd"
                              />
                            </svg>
                          ) : (
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              className="h-4 w-4"
                              viewBox="0 0 20 20"
                              fill="currentColor"
                            >
                              <path
                                fillRule="evenodd"
                                d="M14.707 10.707a1 1 0 01-1.414 0L10 7.414l-3.293 3.293a1 1 0 11-1.414-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 010 1.414z"
                                clipRule="evenodd"
                              />
                            </svg>
                          )}
                        </span>
                      </div>

                      {/* Dropdown Menu */}
                      {dropOpen[1] && (
                        <ul
                          // ref={schemaref}
                          className="absolute z-10 bg-white border border-gray-300 rounded-lg w-full mt-2 shadow-lg max-h-[300px] overflow-auto"
                        >
                          {apiData?.summary.map((option, index) => (
                            <li
                              data-name={"summary"}
                              key={index}
                              className={`px-4 py-2 hover:bg-gray-100 cursor-pointer ${
                                creationData?.summary == option?.name
                                  ? "bg-gray-100"
                                  : ""
                              }`}
                              onClick={(e) =>
                                handleCreateData(e, "summary", null)
                              }
                            >
                              {option.name}
                            </li>
                          ))}
                        </ul>
                      )}
                    </div>

                    {validate && validate?.summary ? (
                      <p className="text-red">
                        {" "}
                        {"*"}
                        {validate.summary}
                      </p>
                    ) : (
                      <></>
                    )}
                  </div>
                </div>
                <div className="flex flex-col w-1/3 min-w-[150px] gap-5">
                  <p className="text-black font-semibold text-20">
                    Page List<span className="text-red">*</span>
                  </p>
                  <div className="relative">
                    {/* Dropdown Button */}
                    <div
                      className="schemadropdown bg-white border-[1px] border-commonborder rounded-[12px] px-3 py-3 w-full text-left flex justify-between items-center text-dimtext"
                      onClick={() => schemaDropdown(2)} // Toggle dropdown for the specific index
                    >
                      <p
                        className={`w-full overflow-hidden  ${
                          Object.values(creationData?.pageList).flat().length
                            ? "text-black"
                            : "text-dimtext"
                        }`}
                      >
                        {Object.values(creationData?.pageList)
                          .flat()
                          .filter(Boolean).length
                          ? Object.values(creationData?.pageList)
                              .flat()
                              .filter(Boolean)
                              .join(", ")
                          : "Select page list"}
                      </p>
                      <span className="ml-2">
                        {!dropOpen[2] ? (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-4 w-4"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                          >
                            <path
                              fillRule="evenodd"
                              d="M5.293 9.293a1 1 0 011.414 0L10 12.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                              clipRule="evenodd"
                            />
                          </svg>
                        ) : (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-4 w-4"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                          >
                            <path
                              fillRule="evenodd"
                              d="M14.707 10.707a1 1 0 01-1.414 0L10 7.414l-3.293 3.293a1 1 0 11-1.414-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 010 1.414z"
                              clipRule="evenodd"
                            />
                          </svg>
                        )}
                      </span>
                    </div>

                    {/* Dropdown Menu */}
                    {dropOpen[2] && (
                      <ul
                        // ref={schemaref}
                        className="absolute z-10 bg-white border border-gray-300 rounded-lg w-full mt-2 shadow-lg max-h-[300px] overflow-auto"
                      >
                        {apiData?.pageList.map((option, index) => (
                          <li
                            data-name={option?.name}
                            key={index}
                            className={`px-4 py-2 hover:bg-gray-100 cursor-pointer flex items-center justify-between `}
                            onClick={(e) => handlePageSelect(option?.name)}
                          >
                            <span>{option.name}</span>
                            <input
                              type="checkbox"
                              className="w-[20px] h-[20px]"
                              checked={
                                creationData?.pageList?.[option.name] ==
                                option?.name
                              }
                            />
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                  {validate && validate?.pageList ? (
                    <p className="text-red">
                      {" "}
                      {"*"}
                      {validate.pageList}
                    </p>
                  ) : (
                    <></>
                  )}
                </div>
              </div>

              <div className="w-full flex flex gap-5 ">
                <div className="flex flex-col gap-5 w-1/2 text-left ">
                  <p className="text-black font-semibold text-20 text-left">
                    Front Cover Alt Text<span className="text-red">*</span>
                  </p>
                  <div className="border-[1px] border-commonborder rounded-[12px] px-3 py-3">
                    <input
                      onKeyDown={(e) => {
                        if (e.key === "Enter") e.preventDefault();
                      }}
                      className="w-full outline-none"
                      type="text"
                      placeholder="Enter alt text"
                      name="frontCover"
                      value={creationData?.frontCover}
                      onChange={(e) => handleCreateData(e, "frontCover", null)}
                    />
                  </div>
                  {validate && validate?.frontCover ? (
                    <p className="text-red">
                      {" "}
                      {"*"}
                      {validate.frontCover}
                    </p>
                  ) : (
                    <></>
                  )}
                </div>
                <div className="flex flex-col gap-5 w-1/2 text-left">
                  <p className="text-black font-semibold text-20 text-left">
                    Back Cover Alt Text<span className="text-red">*</span>
                  </p>
                  <div className="border-[1px] border-commonborder rounded-[12px] px-3 py-3">
                    <input
                      onKeyDown={(e) => {
                        if (e.key === "Enter") e.preventDefault();
                      }}
                      className="w-full outline-none"
                      type="text"
                      placeholder="Enter alt text"
                      name="backCover"
                      value={creationData?.backCover}
                      onChange={(e) => handleCreateData(e, "backCover", null)}
                    />
                  </div>
                  {validate && validate?.frontCover ? (
                    <p className="text-red">
                      {" "}
                      {"*"}
                      {validate.backCover}
                    </p>
                  ) : (
                    <></>
                  )}
                </div>
              </div>

              <div className="w-full shadow-commonshadow rounded-[24px]">
                <Fileupload
                  key={emptyFiles}
                  setSelectedData={setFile}
                  // setFileName={setFileName}
                  category={category}
                  emptyfile={emptyFiles}
                />
              </div>
              <div className="w-full flex text-left gap-5">
                <div className="flex flex-col lg:w-1/3 min-w-[150px] gap-10">
                  <p className="text-black font-semibold text-20">
                    CertifiedBy<span className="text-red">*</span>
                  </p>

                  <div className="w-full flex  gap-5">
                    {apiData?.certified.map((item, i) => (
                      <div key={i} className="flex gap-3">
                        <input
                          className="h-5 w-5 cursor-pointer"
                          type="checkbox"
                          name="certifiedBy"
                          value={item?.name}
                          checked={item?.name === creationData?.certifiedBy}
                          onChange={(e) => {
                            if (creationData?.certifiedBy === item?.name) {
                              handleCreateData(
                                { target: { name: "certifiedBy", value: "" } },
                                "certifiedBy",
                                null
                              );
                            } else {
                              handleCreateData(e, "certifiedBy", null);
                            }
                          }}
                        />
                        <p className="text-18 text-title">{item?.name}</p>
                      </div>
                    ))}
                  </div>
                  {validate && validate?.certifiedBy ? (
                    <p className="text-red">
                      {" "}
                      {"*"}
                      {validate.certifiedBy}
                    </p>
                  ) : (
                    <></>
                  )}
                </div>
                <div className="flex flex-col lg:w-1/3 gap-5">
                  <p className="text-black font-semibold text-20">
                    Roman Page Count<span className="text-red">*</span>
                  </p>
                  <div className="flex flex-col gap-5">
                    <div className="border-[1px] border-commonborder rounded-[12px] px-3 py-3">
                      <input
                        onKeyDown={(e) => {
                          if (e.key === "Enter") e.preventDefault();
                        }}
                        className="w-full outline-none"
                        type="text"
                        placeholder="Enter roman number count"
                        name="RomanPageCount"
                        value={creationData?.RomanPageCount}
                        onChange={(e) =>
                          handleCreateData(e, "RomanPageCount", null)
                        }
                      />
                    </div>
                    {validate && validate?.RomanPageCount ? (
                      <p className="text-red">
                        {" "}
                        {"*"}
                        {validate.RomanPageCount}
                      </p>
                    ) : (
                      <></>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </form>
          <div className="w-full text-right flex gap-4 justify-end mt-10 mb-10">
            <button
              className="py-2 px-5 border-[1px] rounded-lg border-commonborder text-btntext hover:bg-dimtext hover:text-white"
              onClick={handleCancel}
            >
              cancel
            </button>
            <button
              className="py-2 px-5 bg-highlighttext rounded-lg text-white"
              type="submit"
              onClick={(event) => handleSubmit(event)}
            >
              Submit
            </button>
          </div>
        </div>
      ) : (
        <div className="w-full h-[80vh] flex flex-col justify-center">
          <h1 className="text-center text-dimtext font-semibold text-20">
            Problem connecting with network!
            <br />
            Check your connection or contact system Administrator
          </h1>
        </div>
      )}
    </LoadingScreen>
  );
};
